const routes = {
  assistantPath: '/assistant',
  assistantThreadPath: '/assistant/:threadId',
  authPath: '/auth',
  onboardingPath: '/onboarding',
  onboardingCompleteProfilePath: '/onboarding/complete-profile',
  onboardingNotificationsPath: '/onboarding/notifications',
  onboardingSetGoalPath: '/onboarding/set-goal',
  chatPath: '/chat',
  coursePath: '/course/:courseId',
  eventsPath: '/events',
  hubPath: '/hub',
  resourcesPath: '/resources',
  manualPath: '/manual',
  messages: '/messages',
  newTransactionPath: '/progress/new',
  editTransactionPath: '/progress/edit/:id',
  profilePath: '/profile',
  progressPath: '/progress',
  progressLevelPath: '/progress/levels/:level',
  resetPasswordPath: '/auth/reset',
  setPasswordPath: '/auth/recovery',
  setupGoalPath: '/progress/goal',
  signinPath: '/auth/login',
  signupPath: '/auth/signup',
  socialSuccessPublishPath: '/social-success',
  supportFormPath: '/support/submit',
  supportPath: '/support',
  teamPath: '/twinoaks',
  todayPath: '/',
  trainingPath: '/training',
} as const;

export default routes;
